import React, { Component, Fragment } from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './AccordionArea.styles';

import AccordionMenu from '../accordionmenu/AccordionMenu';
import AccordionZone from '../accordionzone/AccordionZone';
import Icon from '../../common/icon/Icon';

class AccordionArea extends Component {
  state = {
    isOpen: false
  };
  options = [
    {
      text: I18n.t('edit.edit'),
      value: 'edit'
    },
    {
      text: I18n.t('delete.delete'),
      value: 'delete'
    }
  ];
  toggleOpen = () => {
    if (!!this.props.area.zoneCount) {
      let isOpen = !this.state.isOpen;
      if (isOpen) {
        this.props.onOpenArea(this.props.area.id);
      }
      this.setState({ isOpen });
    }
  };
  handleAreaActions = action => {
    if (action === 'delete') {
      this.props.delete(this.props.area);
    }else if(action === 'edit'){
      this.props.edit(this.props.area);
    }
  };
  renderZone = (zone, index) => {
    let props: Object = {
      key: index,
      zone,
      locations: this.props.locations,
      onOpenZone: this.props.onOpenZone,
      edit: this.props.onEditZone,
      onDeleteLocation: this.props.onDeleteLocation,
      onEditLocation: this.props.onEditLocation,
      delete: this.props.onDeleteZone,
      ...(!index ? { styles: styles.firstZone } : {})
    };
    return <AccordionZone {...props} />;
  };
  render() {
    let iconStyles = [
      styles.icon,
      ...(!this.props.area.zoneCount ? [styles.iconHidden] : [])
    ];
    return (
      <Fragment>
        <div className={css(styles.base)}>
          <Icon
            value={this.state.isOpen ? 'chevron-up' : 'chevron-down'}
            styles={iconStyles}
            onClick={this.toggleOpen}
          />
          <div className={css(styles.field)}>
            <span className={css(styles.label)}>{I18n.t('assets.area')}</span>
            <span className={css(styles.value)}>{this.props.area.name}</span>
          </div>
          <div className={css(styles.field)}>
            <span className={css(styles.label)}>
              {I18n.t('models.area.indoorOutdoor')}
            </span>
            <span className={css(styles.value)}>
              {this.props.area.location}
            </span>
          </div>
          <div className={css(styles.field)}>
            <span className={css(styles.label)}>
              {I18n.t('models.area.zones')}
            </span>
            <span className={css(styles.value)}>
              {this.props.area.zoneCount}
            </span>
          </div>
          <div className={css(styles.field)}>
            <span className={css(styles.label)}>
              {I18n.t('models.area.locations')}
            </span>
            <span className={css(styles.value)}>
              {this.props.area.locationCount}
            </span>
          </div>
          <AccordionMenu
            styles={styles.options}
            options={this.options}
            handleClick={this.handleAreaActions}
          />
        </div>
        {this.state.isOpen &&
          this.props.area.id in this.props.zones && (
            <Fragment>
              <div className={css(styles.zones)}>
                {I18n.t('assets.zonesLocations')}
              </div>
              {this.props.zones[this.props.area.id].map(this.renderZone)}
            </Fragment>
          )}
      </Fragment>
    );
  }
}

export default AccordionArea;



// WEBPACK FOOTER //
// ./src/components/data/accordionarea/AccordionArea.js